import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styleable from 'react-styleable';
import css from './live-maths.scss';
import ConnectedSubHeading from '../../components/sub-heading/sub-heading';
import ConnectedAllClasses from './all-classes/all-classes';
import ConnectedSingleClass from './single-class/single-class';
import ConnectedStudent from './student/student';
import ConnectedReportRoutes from '../report-routes/report-routes';
import { ALL_STUDENTS } from '../../components/report-filters/filter-constants';
import activeFiltersSelectors from '../../components/report-filters/redux/active-filters/active-filters-selectors';
import EmptyState from '../../components/empty-state/empty-state';
import EMPTY_STATE_VARIANTS from '../../components/empty-state/empty-state-constants';

/**
 * Base container for all Live Maths reports
 */
const LiveMaths = ({ selectedStudentId }) => {
    const routeComps = {
        allClasses: ConnectedAllClasses,
        singleClass: ConnectedSingleClass,
        student: ConnectedStudent
    };

    // export is not available for live maths student report
    const isExportEnabled = selectedStudentId === ALL_STUDENTS;

    return (
        <div className={css.component}>
            <EmptyState variant={EMPTY_STATE_VARIANTS.NO_STUDENTS}>
                <ConnectedReportRoutes components={routeComps}>
                    <ConnectedSubHeading isExportEnabled={isExportEnabled} />
                    <div className={css['report-container']} />
                </ConnectedReportRoutes>
            </EmptyState>
        </div>
    );
};

LiveMaths.propTypes = {
    selectedStudentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

function mapStateToProps(state) {
    return {
        selectedStudentId: activeFiltersSelectors.selectStudentId(state)
    };
}

export default connect(mapStateToProps)(styleable(css)(LiveMaths));



// WEBPACK FOOTER //
// ./containers/live-maths/live-maths.js